module.exports = __webpack_public_path__ + "a28f4991.ttf";